import ApiClient from './ApiClient';

class AssignmentOverviewAPI extends ApiClient {
  constructor() {
    super('assignment_overview', { accountScoped: true });
  }
}

export default new AssignmentOverviewAPI();
